/* eslint-disable camelcase */
import management_company from "pages/management/company";
import management_products from "pages/management/products";
import management_products_categories from "pages/management/products/categories";
import management_stores from "pages/management/stores";
import register_account from "pages/register/account";
import register_checkout from "pages/register/checkout";
import register_close from "pages/register/close";
import register_customers from "pages/register/customers";
import register_open from "pages/register/open";
import register_order from "pages/register/order";
import register_receipt from "pages/register/receipt";
import register_report from "pages/register/report";

const index = {
  management_company,
  management_products,
  management_products_categories,
  management_stores,
  register_account,
  register_checkout,
  register_close,
  register_customers,
  register_open,
  register_order,
  register_receipt,
  register_report
};
/* eslint-enable camelcase */

export default index;
